export default __webpack_public_path__ + "static/media/profit.09d91aa2.jpg";